/* eslint-disable sort-keys */
export const urls: Record<
  'us',
  Record<string, '/l/us/en' | `/l/us/en/${string}`>
> = {
  us: {
    // Home
    '': '/l/us/en/home',

    // Alumni
    alumni: '/l/us/en/alumni',

    // B2B
    enterprise: '/l/us/en/b2b',
    'enterprise/contact': '/l/us/en/b2b/apply',

    // Blog
    blog: '/l/us/en/blog',

    // Campus
    remote: '/l/us/en/campus/rmt',

    // Career
    'career-services': '/l/us/en/career',

    // Courses
    'web-development': '/l/us/en/course/wd',
    'data-analytics': '/l/us/en/course/da',
    'ux-ui-design': '/l/us/en/course/ux',

    // FAQ
    faq: '/l/us/en/faq',

    // Financing Options
    financing: '/l/us/en/financing',

    // Forms
    apply: '/l/us/en/apply',
    apply2: '/l/us/en/full-apply',
    contact: '/l/us/en/contact',
    'financing-form': '/l/us/en/financing-form',
    'thank-you': '/l/us/en/thank-you',

    // Syllabus Forms
    'data-analytics/syllabus': '/l/us/en/syllabus/da',
    'ux-ui-design/syllabus': '/l/us/en/syllabus/ux',
    'web-development/syllabus': '/l/us/en/syllabus/wd',
  },
};
/* eslint-enable sort-keys */
